import React, { memo } from "react"
import { Grid } from "semantic-ui-react"
import { formatCurrency, daysBetweenDates } from "uikit"
import { PAY_FREQUENCY_DIVISOR } from "components/incomes/dropDownOptions"
import "./IncomeStatistics.css"

const IncomeStatistics = memo(({ incomes }) => {
  const partial_year_ratio = until_date => {
    const currentYear = new Date().getFullYear()
    if (!until_date || new Date(until_date).getFullYear() > currentYear) {
      return 1
    } else {
      const days = daysBetweenDates(
        new Date(`${currentYear}-01-01`),
        new Date(until_date)
      )
      return days / 365
    }
  }

  const preTaxIncome = incomes.reduce(
    (acc, inc) =>
      acc +
      (inc.base_amount || inc.payment_amount
        ? (inc.base_amount * partial_year_ratio(inc.until_date) ||
            inc.payment_amount *
              partial_year_ratio(inc.until_date) *
              PAY_FREQUENCY_DIVISOR[inc.pay_frequency]) +
          (inc.bonus ? inc.bonus.amount : 0)
        : inc.monthly_amount * partial_year_ratio(inc.until_date)
        ? 12 * inc.monthly_amount * partial_year_ratio(inc.until_date)
        : inc.amount * partial_year_ratio(inc.until_date)),
    0
  )

  return (
    <Grid className="Income__Statistics__Grid">
      <Grid.Row>
        <Grid.Column verticalAlign="middle" textAlign="center">
          <h1 className="Income__Statistics__TotalFigure">
            {formatCurrency(Math.floor(preTaxIncome))}
          </h1>
          <h5 className="Income__Statistics__FigureLabel">
            TOTAL PRE-TAX INCOME
          </h5>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
})

export default IncomeStatistics
